<template>
  <div>
    <page-title tag="h1" class="mb-4"/>
    <view-page
        baseRoute="risk-codes"
        entity="Risk Codes"
        :button-access="componentAccess"
        :model-entity="modelEntity"
        :page-title="setPageTitle"
    >
      <template v-slot="{ model }">
        <risk-code-form
            v-if="model"
            v-model="model"
            readonly
            ref="form"
            pageTitle="Details"
        />
      </template>
    </view-page>
  </div>
</template>

<script>

import RiskCodeForm from "@/views/pages/risk-codes/RiskCodeForm";
import NotificationMixin from "@/components/mixins/NotificationMixin";
import ViewPage from '../../components/Views/ViewPage';
import PageTitle from '../../components/extra-components/layout/PageTitle';

export default {
  name: "RiskCodeCreate",
  components: {
    RiskCodeForm,
    ViewPage,
    PageTitle
  },
  mixins: [NotificationMixin],
  data() {
    return {
      not_found: false,
      modelEntity: this.$api.riskCode,
      title: '',
      componentAccess: {
        canEdit: {
          route: 'risk-codes.edit',
          access: false,
        },
      }
    };
  },
  methods: {
    setPageTitle(params) {
      if (!params.RiskCodeText) {
        return '';
      }

      return "Risk Code: " + params.RiskCodeText;
    }
  }
};
</script>

<style scoped>

</style>
